import { ICategorys, IGameCell, IGameData } from "@/common/interface";
import Link from "@/components/common/Link";
import MySwiper from "@/components/common/MySwiper";
import { IGameState } from "@/store/game";
import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { SwiperOptions } from "swiper";
import { useInViewport } from "ahooks";
import Img from "@/components/common/Img";
import { comMonitor, replaceUrlTemplate } from "@/utils/com";
import { sendClkLog } from "@/common/selfMonitor";

import "./index.scss";
interface IProps {
  data: IGameData["dataTop"];
  position?: string;
}

const option: SwiperOptions = {
  centeredSlides: false,
  slidesPerGroup: 4,
  loop: false,
  autoplay: false,
};

const ScheduleItem = ({ data = {} as IGameCell, position = "" as string }) => {
  const categoryText =
    data.category && data.category.length > 0
      ? `${ICategorys[data.category]}`
      : `${ICategorys[1]}`;

  const [startTime, setStartTime] = useState(0);
  const onMouseDown = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setStartTime(Date.now());
  };

  const onMouseUp = (e: React.MouseEvent) => {
    if (Array.isArray(data.clktk) && data.clktk.length) {
      const now = Date.now();
      data.clktk.forEach((url) => {
        const realUrl = replaceUrlTemplate(url, e, startTime, now);
        comMonitor(realUrl);
      });
    }
  };
  return (
    <div className="schedule__item swiper-slide">
      <div className="schedule__title">
        <span className="schedule__time">{data.calendar_title}</span>
      </div>
      <div onMouseDown={onMouseDown} onMouseUp={onMouseUp}>
        <Link
          softId={data.soft_id}
          openType={data.open_type}
          href={data.href}
          exec={data.exec}
          dataText={categoryText}
          position={position}
          name={data.name}
          comAds={data.clktk}
          category={data.category}
        >
          <div className="schedule__content">
            <Img src={data.pic_url} className="schedule__img" />
            <h3 className="schedule__name">{data.name}</h3>
            <p className="schedule__desc">{data.calander_desc}</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

const Schedule = ({ data, position }: IProps) => {
  const list = data.map((item, index) => (
    <ScheduleItem key={index} data={item} position={position} /> // 舍去key，避免ScheduleItem渲染错误
  ));

  const nodeRef = useRef<HTMLDivElement>(null);
  const [lock, setLock] = useState(false);
  const [inViewport, ratio] = useInViewport(nodeRef, {
    threshold: [0.1, 0.5, 1],
  });
  useEffect(() => {
    if (inViewport && !lock && ratio && ratio >= 0.1 && data[0].soft_id) {
      const monitorIds = data
        .reduce<string>((prev, current) => {
          return (
            prev +
            "|" +
            `${current.soft_id}$${current.name}$${
              current.category && current.category.length
                ? ICategorys[current.category]
                : ICategorys[1]
            }`
          );
        }, "")
        .slice(1);

      const params = {
        cid: position, //事件名称组名
        // c : "下载", //事件名称
        // from: (category && category.length) ? ICategorys[category] : '',
        title: monitorIds,
      };
      sendClkLog(params, "track");
      setLock(true);

      const urlItems = data.filter((item) => {
        return item.imptk;
      });
      urlItems.forEach((item) => {
        item.imptk.forEach((img: string) => {
          comMonitor(img);
        });
      });
    }
  }, [inViewport, data, lock, ratio, position]);

  return (
    <div ref={nodeRef} className="schedule" data-bk="日程表">
      <MySwiper id="scheduleSwiper" option={option}>
        {list}
      </MySwiper>
    </div>
  );
};

const mapStateToProps = ({ gameData: { dataTop } }: IGameState) => ({
  data: dataTop,
});
export default connect(mapStateToProps)(Schedule);
